import React, { useCallback, useEffect, useState } from 'react';
import Select from 'react-select';
import { Helmet } from 'react-helmet';
import { useQuill } from 'react-quilljs';
import { Button, Card, Col, Container, Form, Nav, Row } from 'react-bootstrap';
import { Icon } from '@lomarengas/design-system';
import 'quill/dist/quill.snow.css';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  getAllTenantsAsync,
  getTenantDetailsAsync,
  OfficeListItem,
  OfficeUpdateData,
  selectTenantDetails,
  selectTenantDetailsLoadingStatus,
  selectTenants,
  selectTenantsLoadingStatus,
  TenantsQueryFilters,
  updateTenantAsync,
} from './OfficesSlice';
import { LOADING_STATUS } from '../../common/constants';

function Offices() {
  const dispatch = useAppDispatch();
  const tenants = useAppSelector(selectTenants);
  const tenantsLoadingStatus = useAppSelector(selectTenantsLoadingStatus);
  const tenantDetails = useAppSelector(selectTenantDetails);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const tenantDetailsLoadingStatus = useAppSelector(
    selectTenantDetailsLoadingStatus,
  );
  const { quill, quillRef } = useQuill();
  const [filtering, setFiltering] = useState<TenantsQueryFilters>({
    searchTerm: '',
  });
  const initFetch = useCallback(() => {
    dispatch(getAllTenantsAsync(filtering));
  }, [dispatch, filtering]);
  useEffect(() => {
    initFetch();
  }, [initFetch]);
  const [tenantTemp, setTenant] = useState<OfficeListItem>({
    id: '',
    name: '',
  });
  function getUpdateData(tempData) {
    const updateAddonData: OfficeUpdateData = {
      id: tempData.id,
      name: tempData.name,
    };

    return updateAddonData;
  }
  const saveTenant = event => {
    const data = getUpdateData(tenantDetails);
    dispatch(updateTenantAsync(data));
  };
  const handleSelectChange = (selectedOption, name) => {
    const newTenant = { ...tenantTemp };
    newTenant[name] = selectedOption.value;
    newTenant.name = selectedOption.label;
    setTenant(newTenant);
    setActiveTabIndex(0);
    dispatch(getTenantDetailsAsync(newTenant.id));
  };
  const tenantOptions = tenants.map(tenant => {
    return { value: tenant.id, label: tenant.name };
  });

  return (
    <>
      <Helmet>
        <title>Asetukset - Varaamot</title>
      </Helmet>

      <Container fluid>
        <div className="header mb-0">
          <div className="header-body pt-0">
            <Row className="align-items-center">
              <Col xs="auto">
                <Button variant="white" className="btn-rounded-circle">
                  <Icon Name="arrow-left" />
                </Button>
              </Col>
              <Col>
                <h6 className="text-uppercase text-muted mb-2">Asetukset</h6>
                <h1 className="header-title">Varaamot</h1>
                <Button className="w-100" onClick={saveTenant}>
                  Tallenna
                </Button>
                <Select
                  className="mt-3 col-md-5"
                  inputId="id"
                  name="id"
                  placeholder="Valitse Varaamo"
                  isClearable
                  isSearchable
                  options={tenantOptions}
                  onChange={option => handleSelectChange(option, 'id')}
                  value={tenantOptions.filter(
                    option => option.value === tenantTemp.id,
                  )}
                />
              </Col>

              <Col xs="auto">
                <Form>
                  <Form.Check inline label="fi" checked />
                  <Form.Check inline label="en" />
                  <Form.Check inline label="ru" />
                </Form>
              </Col>
            </Row>
          </div>
        </div>

        {tenantDetailsLoadingStatus === LOADING_STATUS.IDLE && (
          <Nav
            variant="tabs"
            className="mb-5 nav-overflow text-nowrap"
            defaultActiveKey="link-0"
          >
            <Nav.Item>
              <Nav.Link
                eventKey="link-0"
                onClick={() => setActiveTabIndex(0)}
                className={activeTabIndex === 0 ? 'active' : ''}
              >
                Perustiedot:
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="link-1"
                onClick={() => setActiveTabIndex(1)}
                className={activeTabIndex === 1 ? 'active' : ''}
              >
                Asetukset:
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-2">Varausehdot</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-3">Tietosuojalauseke</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-4">Peruutusturva</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-5">Asiakasliittymä</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-6">Virkailijaliittymä</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-7">Sopimustekstit</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-8">Tervetulotekstit</Nav.Link>
            </Nav.Item>
          </Nav>
        )}
        {activeTabIndex === 0 && (
          <div>
            {tenantDetailsLoadingStatus === LOADING_STATUS.IDLE &&
              tenantDetails != null && (
                <div>
                  <Row className="justify-content-between">
                    <Col>
                      <Card.Body>
                        <Card>
                          <Card.Title>Varaamon nimi</Card.Title>
                          <Card.Text>
                            <input value={tenantDetails.name} />
                          </Card.Text>
                        </Card>
                      </Card.Body>
                    </Col>
                    <Col>
                      <Card.Body>
                        <Card>
                          <Card.Title>Viivästyskorko:</Card.Title>
                          <Card.Text>
                            <input value={tenantDetails.delayFeeP} />
                          </Card.Text>
                        </Card>
                      </Card.Body>
                    </Col>
                  </Row>
                </div>
              )}
          </div>
        )}
        {activeTabIndex === 1 &&
          tenantDetailsLoadingStatus === LOADING_STATUS.IDLE &&
          tenantDetails != null && (
            <>
              <Row>
                <Card.Body>
                  <Card>
                    <Card.Title>Tiliöinnit:</Card.Title>
                    <Row>
                      <Col>
                        <Card.Body>
                          <Card>
                            <Card.Title>Myyntisaamiset tili:</Card.Title>
                            <Card.Text>
                              <input
                                value={tenantDetails.salesClaimAccountNumber}
                              />
                            </Card.Text>
                          </Card>
                        </Card.Body>
                      </Col>
                      <Col>
                        <Card.Body>
                          <Card>
                            <Card.Title>Ostovelat tili:</Card.Title>
                            <Card.Text>
                              <input
                                value={tenantDetails.purchaseDeptAccountNumber}
                              />
                            </Card.Text>
                          </Card>
                        </Card.Body>
                      </Col>
                      <Col>
                        <Card.Body>
                          <Card>
                            <Card.Title>
                              Ennakkomaksun myyntiennakot tili:
                            </Card.Title>
                            <Card.Text>
                              <input
                                value={
                                  tenantDetails.advanceFeeAdvanceSalesAccountNumber
                                }
                              />
                            </Card.Text>
                          </Card>
                        </Card.Body>
                      </Col>
                      <Col>
                        <Card.Body>
                          <Card>
                            <Card.Title>Ennakkomaksu tili:</Card.Title>
                            <Card.Text>
                              <input
                                value={
                                  tenantDetails.advanceFeeSalesAccountNumber
                                }
                              />
                            </Card.Text>
                          </Card>
                        </Card.Body>
                      </Col>
                    </Row>
                  </Card>
                </Card.Body>
              </Row>
              <Row>
                <Card.Body>
                  <Card>
                    <Card.Title>Wintime:</Card.Title>
                    <Row>
                      <Col>
                        <Card.Body>
                          <Card>
                            <Card.Title>Wintime varaamon nimi:</Card.Title>
                            <Card.Text>
                              <input value={tenantDetails.wintimeSiteName} />
                            </Card.Text>
                          </Card>
                        </Card.Body>
                      </Col>
                      <Col>
                        <Card.Body>
                          <Card>
                            <Card.Title>Wintime myynti tositelaji:</Card.Title>
                            <Card.Text>
                              <input
                                value={tenantDetails.wintimeSaleVoucherType}
                              />
                            </Card.Text>
                          </Card>
                        </Card.Body>
                      </Col>
                      <Col>
                        <Card.Body>
                          <Card>
                            <Card.Title>Wintime osto tositelaji:</Card.Title>
                            <Card.Text>
                              <input
                                value={tenantDetails.wintimePurchaseVoucherType}
                              />
                            </Card.Text>
                          </Card>
                        </Card.Body>
                      </Col>
                      <Col>
                        <Card.Body>
                          <Card>
                            <Card.Title>
                              Wintime ennakkomaksu tositelaji:
                            </Card.Title>
                            <Card.Text>
                              <input
                                value={
                                  tenantDetails.wintimeAdvanceFeeSalesVoucherType
                                }
                              />
                            </Card.Text>
                          </Card>
                        </Card.Body>
                      </Col>
                      <Col>
                        <Card.Body>
                          <Card>
                            <Card.Title>Viitteen etuliite:</Card.Title>
                            <Card.Text>
                              <input
                                value={tenantDetails.referenceNumberPrefix}
                              />
                            </Card.Text>
                          </Card>
                        </Card.Body>
                      </Col>
                    </Row>
                  </Card>
                </Card.Body>
              </Row>
            </>
          )}
      </Container>
    </>
  );
}

export default Offices;
